// extracted by mini-css-extract-plugin
export default {"navTabWrapper":"NavTabWrapper_navTabWrapper__3Bfws","navTab":"NavTabWrapper_navTab__VuIbk","current":"NavTabWrapper_current__wTMv1"};